import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menu: 'project',
    categoryId:0,
  },

  mutations: {
    ['changeMenu'](state, arr) {
      state.menu = arr;
    },
    ['changeCategoryId'](state, arr) {
      state.categoryId = arr;
    },
  }
})



// WEBPACK FOOTER //
// ./src/base/store.js